export const announcementDictionaries = new Map<string, string>()
    .set("organisation", "kind")
    .set("organisation_en", "kind")
    .set("classifier_dk", "dk021_uk");
    // .set("classifier_cpv", "cpv_en");

